import { generateUUID } from '../../components/utils';
import { createProduct } from './product-factory';

export type CreateOrderItemOptions = {
	product?: ISheetProduct,
	template: ISheetProductTemplate,
	material?: ISheetMaterial,
	waterDrainageProduct?: IWaterDrainageProduct,
	infastingProduct?: IInfastningProduct,
	ovrigtProduct?: IOvrightProduct,
	ordered?: Date,
	selected?: boolean
}

export function createOrderItem(
	options: CreateOrderItemOptions,
	fallbackMaterials: ISheetMaterial[]
): IOrderItem {
	const product: any = options.product || createProduct(options.template!, options.material, fallbackMaterials);
	const number = generateUUID(4, { numericOnly: true });
	const orderItem: IOrderItem = {
		_id: undefined!,
		ordered: options.ordered,
		selected: options.selected,
		product: product,
		number: number,
		render: options.template.name + " " + number,
		quantity: 1
	}
	return orderItem;
}

export function createSameOrderItem(product: ISheetProduct, orderItem: IOrderItem): IOrderItem {
	const number = generateUUID(4, { numericOnly: true });
	const newOrderItem: IOrderItem = {
		_id: undefined!,
		ordered: undefined,
		selected: true,
		product: product,
		number: number,
		render: orderItem.render.slice(0, -4) + number,
		quantity: 1
	}
	return newOrderItem;
}

export function createWaterDrainageOrderItem(option: CreateOrderItemOptions[]): IOrderItem[] {
	const orderItem = option && option.map((options: any) => {
		const product: any = options
		const number = generateUUID(4, { numericOnly: true });
		return {
			_id: undefined,
			type: 'waterDrainage',
			ordered: options.ordered,
			selected: true,
			product: undefined,
			waterDrainageProduct: product,
			infastingProduct: undefined,
			ovrigtProducts: undefined,
			number: number,
			render: options.title + " " + number,
			quantity: options.quantity,
		}
	});
	return orderItem as unknown as IOrderItem[];
}

export function createInfastingOrderItem(option: CreateOrderItemOptions[]): IOrderItem[] {
	const orderItem = option && option.map((options: any) => {
		const product: any = options
		const number = generateUUID(4, { numericOnly: true });
		return {
			_id: undefined,
			type: 'infästning',
			infastingProduct: product,
			ordered: options.ordered,
			selected: options.selected,
			product: undefined,
			waterDrainageProduct: undefined,
			ovrigtProducts: undefined,
			number: number,
			render: options.name || options.title + " " + number,
			quantity: options.quantity
		}
	})
	return orderItem as unknown as IOrderItem[];
}

export function createOvrigtOrderItem(option: CreateOrderItemOptions[]): IOrderItem[] {
	const orderItem = option && option.map((options: any) => {
		const product: any = options
		const number = generateUUID(4, { numericOnly: true });
		return {
			_id: undefined,
			type: 'övrigt',
			ordered: options.ordered,
			selected: options.selected,
			product: undefined,
			waterDrainageProduct: undefined,
			infastingProduct: undefined,
			ovrigtProduct: product,
			number: number,
			render: options.name || options.title + " " + number,
			quantity: options.quantity
		}
	})
	return orderItem as unknown as IOrderItem[];
}
